/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function SuccessfulUpgrade() {
  return (
    <Stack alignItems="center" justifyContent="center">
      <Typography variant="h5">
        Payment information saved successfully!
      </Typography>
      <Typography variant="h3">
        You can create unlimited number of AllegroGraph servers without any
        restrictions on their performance.
      </Typography>
    </Stack>
  );
}
